import { LeasingResponse, ThreeYearResponse, FinancingResponse, TransportTypesResponse, LeasingRegional } from './types';
import { agroApi } from "../../../../redux/api/api";

export const leasingApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeasingData: builder.query<LeasingResponse, string>({
      query: (year) => ({
        url: '/departments/mechanization/leasing-register/analytical-data/for-year',
        method: 'GET',
        params: { year }
      }),
      keepUnusedDataFor: 0,
    }),
    getLeasingFinancingData: builder.query<FinancingResponse, string>({
      query: (year) => ({
        url: '/departments/mechanization/leasing-register/total-financing',
        method: 'GET',
        params: { year }
      }),
      keepUnusedDataFor: 0,
    }),
    getLeasingThreeYearData: builder.query<ThreeYearResponse, void>({
      query: () => ({
        url: '/departments/mechanization/leasing-register/transport-count-last-three-years',
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    getTransportbyRegion: builder.query<TransportTypesResponse, { year?: string; territorialUnitId: number }>({
      query: ({ year, territorialUnitId }) => ({
        url: '/departments/mechanization/leasing-register/transport-type-count-by-region',
        method: 'GET',
        params: {
          ...(year && { year }),
          territorialUnitId
        }
      }),
      keepUnusedDataFor: 0,
    }),
    getTransportTypesCount: builder.query<TransportTypesResponse, number>({
      query: (year) => ({
        url: '/departments/mechanization/leasing-register/transport-type-count',
        method: 'GET',
        params: {
          year: year.toString(),
        }
      }),
      keepUnusedDataFor: 0,
    }),
    getLeasingRegional: builder.query<LeasingRegional, string | void>({
      query: (year) => ({
        url: '/departments/mechanization/leasing-register/leasing-stats-by-region',
        method: 'GET',
        params: year ? { year } : {}
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const { 
  useGetLeasingDataQuery, 
  useGetLeasingFinancingDataQuery, 
  useGetLeasingThreeYearDataQuery,
  useGetTransportbyRegionQuery,
  useGetTransportTypesCountQuery, 
  useGetLeasingRegionalQuery
} = leasingApi;